import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Field,
  Input,
  Spinner,
} from "@fluentui/react-components";
import { DismissRegular } from "@fluentui/react-icons";
import { useEffect, useState } from "react";
import { UpdateUserGroup, UserGroupEmail } from "../../models/userGroup";
import { updateUserGroup } from "../../services/userGroupService";

type Props = {
  open: boolean;
  onClose: () => void;
  userGroupID: number;
  currentName: string;
  existingEmails: UserGroupEmail[];
  onRenamed?: () => void;
};

const RenameUserGroupDialog = (props: Props) => {
  const [name, setName] = useState(props.currentName);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (props.open) setName(props.currentName);
  }, [props.open, props.currentName]);

  const handleSave = async () => {
    if (!name.trim()) return;
    const submitData: UpdateUserGroup = {
      UserGroupID: props.userGroupID,
      UserGroupName: name.trim(),
      Emails: props.existingEmails,
    };
    setSaving(true);
    try {
      await updateUserGroup(submitData);
      props.onRenamed?.();
      props.onClose();
    } catch (err) {
      console.error("Error renaming group:", err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog
      open={props.open}
      onOpenChange={(_e, data) => !data.open && props.onClose()}
      modalType="alert"
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <Button
                shape="circular"
                appearance="subtle"
                aria-label="Stäng"
                icon={<DismissRegular />}
                onClick={props.onClose}
              />
            }
          >
            Ändra namn på grupp
          </DialogTitle>
          <DialogContent>
            <div className="pt-2">
              <Field label="Gruppnamn">
                <Input
                  value={name}
                  onChange={(_, data) => setName(data.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleSave()}
                />
              </Field>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={props.onClose} disabled={saving}>
              Avbryt
            </Button>
            <Button
              appearance="primary"
              onClick={handleSave}
              disabled={saving || !name.trim()}
              icon={saving ? <Spinner size="tiny" /> : undefined}
            >
              {saving ? "Sparar..." : "Spara"}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default RenameUserGroupDialog;
